import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DetectTouchService } from '../../services/detectTouch.serivce';
import { GridLayoutService } from '../../services/grid-layout.service';
import { MlImageDeduplicationService } from 'app/+stories/new/ml-image-deduplication.service';
import { PhotoGridService } from 'app/services/photo-grid.service';

import { ImagePreprocessingService } from 'app/+stories/new/image-preprocessing.service';
import { Observable } from 'rxjs';
import { ImageModel } from 'app/+stories/new/_models/image.model';

import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { bool } from 'aws-sdk/clients/signer';
import { FirebaseService } from 'app/services/firebase.service';


@Component({
  selector: 'photo-grid',
  templateUrl: './photo-grid.component.html',
  styleUrls: ['./photo-grid.component.scss'],
  animations: [
    trigger('item', [
      transition('void => *', [
        style({ opacity: 0 }),  // initial
        animate('0.25s',
          style({ opacity: 1 }))  // final
      ]),
    ]),
  ],
})
export class PhotoGridComponent implements OnInit {

  @Input() photos: ImageModel[];
  @Input() selectionMode: 'select' | 'remove';
  @Input() isSelected;
  @Input() selectImagesScreen;
  @Input() projectId;
  @Output() toggle = new EventEmitter();
  @Output() remove = new EventEmitter();
  showModal = false;
  modalContent: ImageModel;
  modalWidth = 0;
  dedup = false;

  checkingForDuplicates: Observable<boolean>;
  isDeduping: Observable<boolean>;
  dedupCount: Observable<number>;
  isPreprocessing: Observable<boolean>;
  processedCount: Observable<number>;
  totalPhotoCount: Observable<number>;

  warmingUpModel: Observable<boolean>;

  constructor(
    public gridLayoutService: GridLayoutService,
    public detectTouchService: DetectTouchService,
    public mlImageDeduplicationService: MlImageDeduplicationService,
    public photoGridService: PhotoGridService,
    public imagePreprocessingService: ImagePreprocessingService,
    public firebaseService: FirebaseService,
  ) {
    this.checkingForDuplicates = this.photoGridService.dedup;
    this.isDeduping = this.photoGridService.dedupdone;
    this.isPreprocessing = this.imagePreprocessingService.isPreprocessing;
    this.dedupCount = this.imagePreprocessingService.dedupliCationCount;
    this.processedCount = this.imagePreprocessingService.imagePreprocessCount;
    this.totalPhotoCount = this.imagePreprocessingService.totalPhotoCount;
    this.warmingUpModel = this.mlImageDeduplicationService.warmingUp;
  }

  sortablejsOptions: any = {
    animation: 300,
    forceFallback: true,
    scrollSensitivity: 300,
    delay: this.detectTouchService.isTouch() ? 200 : 0,
  };

  ngOnInit(): void {
    if (this.selectImagesScreen) {
      this.mlImageDeduplicationService.loadModel();
    }
  }

  isAllManaged(photo) {
    return photo.managed;
  }

  onImagePress(event: any) {
    if (this.detectTouchService.isTouch()) {
      event.preventDefault();
    }
  }

  onImageClick(item: ImageModel, normalGrid) {
    this.modalWidth = 0;
    if (this.selectionMode === 'select') {
      if (item.duplicateList.length > 1 && !normalGrid) {
        this.firebaseService.logEvent('design_request_duplicates_view', {
          project_id: this.projectId
        });
        this.showModal = true;
        this.modalContent = item;
        this.modalContent.duplicateList.sort((a, b) => {
          return a.date.valueOf() - b.date.valueOf();
        });
        this.modalContent.duplicateList.forEach(duplicate => {
          this.modalWidth += this.gridLayoutService.itemRenderedWidth(
            duplicate.previewWidth,
            duplicate.previewHeight, 200);
        });
        this.modalWidth += 80;
      } else {
        this.toggle.emit(item);
      }
    }
  }

  onImageClick2(item) {
    if (this.selectionMode === 'select') {
      this.toggle.emit(item);
    }
  }

  validationSelection(modalContent: ImageModel) {
    this.showModal = false;
    let parent: ImageModel;
    let previous: ImageModel;
    let orphanDuplicates = [];
    const hasAnySelected = modalContent.duplicateList.find(({ unchecked }) => unchecked === false) ? true : false;

    if (hasAnySelected) {
      modalContent.duplicateList.forEach((element, index) => {
        if (!element.unchecked && index !== 0) {
          this.firebaseService.logEvent('design_request_duplicates_split', {
            project_id: this.projectId
          });
        }
        if (!element.unchecked) {
          parent = element;
          parent.duplicateList = [];
          if (parent.duplicateList.length === 0) {
            parent.duplicateList.push(parent);
          }
          element.isDuplicate = false;
          parent.duplicateList = parent.duplicateList.concat(orphanDuplicates);
          orphanDuplicates = [];
        } else {
          element.isDuplicate = true;
          if (!parent) {
            orphanDuplicates.push(element);
          } else {
            if (!parent.duplicateList.find(e => e === element)) {
              parent.duplicateList.push(element);
            }
          }
          element.duplicateList = [];
        }
        previous = element;
      });
    }
  }

  preventDrag(event) {
    event.stopPropagation();
  }

  preventMouseMove(event: any) {
    if (this.detectTouchService.isTouch()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  trackByFn(index, item) {
    return index;
  }
}
